import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { theme } from '../../layout/theme';
import { Img } from '../../Image/wrappers';

import { Badge } from '../../Badge/wrappers';
import { OriginalTotal, ReferencePrice } from '../../ProductPrices/wrappers';

type StyledFloaterProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  posTop: number;
  posTopMobile?: number;
  posLeft: number;
  posLeftMobile?: number;
  textColor?: string;
  inPanel?: boolean;
};

export const Floater = styled.div<StyledFloaterProps>`
  position: absolute;
  top: ${(props) => `${props.inPanel ? props.posTopMobile : props.posTop}%`};
  left: ${(props) => `${props.inPanel ? props.posLeftMobile : props.posLeft}%`};
  transform: translate(-50%, -50%);
  color: ${(props) => (props.textColor ? props.textColor : theme.colors.text.onColor)};
  width: 175px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${theme.screens.LtMd} {
    top: ${(props) => (props.posTopMobile ? `${props.posTopMobile}%` : `${props.posTop}%`)};
    left: ${(props) => (props.posLeftMobile ? `${props.posLeftMobile}%` : `${props.posLeft}%`)};

    &.m-size-small {
      width: 75px;
    }
    &.m-size-medium {
      width: 100px;
    }
    &.m-size-large {
      width: 125px;
    }
  }

  ${theme.screens.Md} {
    width: 220px;

    &.d-size-small {
      width: 125px;
    }
    &.d-size-medium {
      width: 150px;
    }
    &.d-size-large {
      width: 175px;
    }
  }

  ${Badge} {
    margin-bottom: ${size(0.5)};
  }

  ${ReferencePrice} {
    color: inherit;
  }

  ${OriginalTotal} {
    color: inherit;
  }
`;

export const FloaterImage = styled(Img)`
  width: auto;
  max-width: 100%;
  max-height: 100%;
  min-height: 0 !important;
`;

export const FloaterLink = styled.a`
  text-decoration: none;
  line-height: 1;
  display: block;
  width: 100%;
`;

export const FloaterPreHeading = styled.div`
  color: ${theme.colors.text.highlight};
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1rem;
`;

export const FloaterHeading = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 14px;

  ${theme.screens.Md} {
    font-size: 16px;
  }
`;
